module.exports = __webpack_public_path__ + "static/media/select.8c766f63.svg";